/* global _ */
import {
  name,
  mixins,
  props,
  data,
} from './config'

import {formats, parseDateTime, formatDate} from '../../../../lib/dates'

export default {
  name,
  props,
  mixins,
  data() {
    return {
      ...data,
      eventSpace: 'user.profile.orders',
      sortState: 'desc',
      pageIndex: this.pageStart || 0,
    }
  },
  computed: {
    tableView() {
      return this.isListViewNotPossible ? 'grid' : this.view
    },
    isGrid() {
      return this.tableView == 'grid'
    },
    isListViewNotPossible() {
      return this.appWidth <= this.listViewMinWidth
    },
    sortedAsc() {
      return this.sortState === 'asc'
    },
    sortedDesc() {
      return this.sortState === 'desc'
    },
    ordersCount() {
      return _.size(this.allOrders || {})
    },
    hasVisibleOrder() {
      return !!this.filteredOrders.length
    },
    filteredOrders() {
      const orderFactor = this.sortedAsc ? 1 : -1
      const sorted = this.allOrders.sort((a, b) =>
        orderFactor * (a.created_at.replace(/\D/g, '') - b.created_at.replace(/\D/g, ''))
      )
      const start = this.pageIndex * this.pageSize
      const end = start + this.pageSize
      const visible = _.slice(sorted, start, end)
      return visible
    },
    allOrders() {
      return this.orders || []
    },
    pageNumber() {
      return this.pageIndex + 1
    },
    pageCount() {
      return this.paginate ? Math.ceil(this.ordersCount / this.pageSize) : 1
    },
    hasPagination() {
      return this.paginate && this.pageCount > 1
    }
  },

  async created() {
    await this.fetch()
  },

  methods: {
    async fetch() {
      this.emit('fetch.init')
      try {
        this.isBeingProcessed = true
        const [data] = await this.promise('user.orders.get')
        const orders = this.orders = data.data || {}
        this.$emit('success', orders)
        this.emit('fetch.success', orders)
      } catch (e) {
        this.$emit('error', e)
        this.emit('fetch.error', e)
      } finally {
        this.emit('fetch.end')
        this.isBeingProcessed = false
      }
    },
    sortDesc() {
      this.sortState = 'desc'
    },
    sortAsc() {
      this.sortState = 'asc'
    },
    nextPage() {
      this.goPage(this.pageIndex + 2)
    },
    prevPage() {
      this.goPage(this.pageIndex)
    },
    getCardDetails(orderItem) {
      return _.get(orderItem, 'transaction.data.cc_type') + '*' +
        _.get(orderItem, 'transaction.data.cc_number', '').slice(-4)
    },
    goPage(pageNumber) {
      const index = pageNumber - 1
      if (index >= 0 && index < this.pageCount) {
        this.pageIndex = index
      }
    }
  }
}
